import { UPDATEBILLABLE_FAIL, UPDATEBILLABLE_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateBillableReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEBILLABLE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEBILLABLE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateBillableReducer;
